import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import pickBy from "lodash-es/pickBy"

// Configure request setup
const serviceName = 'OpportunityService'
const host = servicesConfig.Opportunities
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Helper function for waiting
function wait(ms: number, value: any) {
  return new Promise(resolve => setTimeout(resolve, ms, value))
}

// Define service object with methods
const OpportunityService = {
  create: (data: { [key: string]: any }) => 
    request().post('/', data).then(responseBody),
    
  read: (id: string) => 
    request().get(`/${id}`).then(responseBody),
    
  update: (id: string, data: { [key: string]: any }) =>
    request().put(`/${id}`, data).then(responseBody),
    
  delete: (id: string) => 
    request().delete(`/${id}`).then(responseBody),
    
  export: (queryData: { [key: string]: any }) => {
    const url = pickBy(
      queryData,
      v => v !== null && v !== undefined && v !== ''
    )
    return request().get(
      `/export?${Object.keys(url)
        .map(key => key + '=' + url[key])
        .join('&')}`
    ).then(responseBody)
  },
  
  search: (queryData: { [key: string]: any }) => {
    const url = pickBy(
      queryData,
      v => v !== null && v !== undefined && v !== ''
    )
    return request().get(
      `/search?${Object.keys(url)
        .map(key => key + '=' + url[key])
        .join('&')}`
    ).then(responseBody)
  },
  
  restoreOpportunity: (id: string, forceRestore: boolean) =>
    request().put(`/${id}/restore`, { forceRestore: forceRestore }).then(responseBody),

  getOpportunityPipeline: (queryData: { [key: string]: any }) => {
    const url = pickBy(
      queryData,
      v => v !== null && v !== undefined && v !== ''
    )
    return request().get(
      `/pipelines/search?${Object.keys(url)
        .map(key => key + '=' + url[key])
        .join('&')}`
    ).then(responseBody)
  },

  getPipelines: (locationId: string) =>
    request().get(`/pipelines?locationId=${locationId}`).then(responseBody),
    
  createPipeline: (data: { [key: string]: any }) =>
    request().post('/pipelines', data).then(responseBody),
    
  updatePipeline: (id: string, data: { [key: string]: any }) =>
    request().put(`/pipelines/${id}`, data).then(responseBody),
    
  deletePipeline: (id: string) => 
    request().delete(`/pipelines/${id}`).then(responseBody),

  getPipelinesPermissions: (locationId: string) =>
    request().get(`/pipelines/permissions/location?locationId=${locationId}`).then(responseBody),
  
  bulkDeleteOpportunities: (data: {
    pipelineId: string
    locationId: string
  }) => request().post('/bulk/delete', data).then(responseBody),
  
  LostReasons: {
    list: (locationId: string) => 
      request().get(`/lost-reason?locationId=${locationId}`).then(responseBody),
      
    create: (queryData: { [key: string]: any }) =>
      request().post('/lost-reason', queryData)
        .then(responseBody)
        .then(value => wait(3000, value)),
        
    update: (lostReasonId: string, queryData: { [key: string]: any }) =>
      request().put(`/lost-reason/${lostReasonId}`, queryData)
        .then(responseBody)
        .then(value => wait(3000, value)),
        
    delete: (lostReasonId: string) =>
      request().delete(`/lost-reason/${lostReasonId}`)
        .then(responseBody)
        .then(value => wait(3000, value)),
  }
}

export default OpportunityService
